import { t } from '@sm/intl';
import { DetailsFeatureRules } from '~pricing/transformers/details/types';
import { Packages } from '~shared/constants/pricing';
import CELL_COPY from '~pricing/lib/PackageFeatures/details/cellCopy';
import experimentDetailsCopy from '../../copy/experimentDetailsCopy';

const allExceptBasicFeatures = [
  'grow_2529_database_response_view',
  'create_print_enabled',
  'download_as_ppt',
  'create_print_enabled',
].reduce(
  (acc, key) => ({
    ...acc,
    [key]: (packageName: Packages): boolean => packageName !== Packages.Basic,
  }),
  {}
);

const formsAndBasic = [Packages.Basic, Packages.FormsAnnual, Packages.FormsMonthly];
const formsAndEnhanced = [
  Packages.AdvantageAnnual,
  Packages.PremierAnnual,
  Packages.FormsAnnual,
  Packages.FormsMonthly,
];
const allExceptForms = [
  Packages.AdvantageAnnual,
  Packages.PremierAnnual,
  Packages.StarterAnnual,
  Packages.StandardMonthly,
];
const allPackages = [...formsAndBasic, ...allExceptForms];

export default {
  ...allExceptBasicFeatures,
  mobile_apps_ios_android: (): string | boolean => true,

  grow_2529_survey_create_limit: (): string => t(CELL_COPY.UNLIMITED),

  grow_2529_questions_per_form_survey: (packageName: Packages): string =>
    packageName === Packages.Basic ? t(CELL_COPY.create_question_limit, { amount: 10 }) : t(CELL_COPY.UNLIMITED),

  grow_2529_database_response_view: (packageName: Packages): boolean => allPackages.includes(packageName),

  collector_create_limit: (packageName: Packages): string =>
    packageName === Packages.Basic
      ? t(experimentDetailsCopy.grow_2529_use_collectors, { number: 3 })
      : t(CELL_COPY.UNLIMITED),

  grow_2529_recurring_surveys: (packageName: Packages): boolean =>
    packageName === Packages.PremierAnnual || packageName === Packages.AdvantageAnnual,

  grow_2529_payment_qt: (packageName: Packages): boolean => formsAndEnhanced.includes(packageName),
  grow_2529_file_upload: (packageName: Packages): boolean => formsAndEnhanced.includes(packageName),

  analyze_combine_filters: (packageName: Packages): string | boolean => {
    return formsAndBasic.includes(packageName) ? t(CELL_COPY.BASIC_COMPARE_FILTER) : true;
  },

  rating_question_type: (packageName: Packages): boolean => allExceptForms.includes(packageName),

  analyze_trends_enabled: () => true,

  response_quality_enabled: (packageName: Packages): boolean => packageName === Packages.PremierAnnual,

  analyze_can_ta_tag: (packageName: Packages): string =>
    allExceptForms.includes(packageName) ? t(CELL_COPY.MANUAL) : '',
} as DetailsFeatureRules;
